<div class="labelWithIcon">
  <i [attr.class]="data.iconCssClass" aria-hidden="true"></i>{{ data.text }}
</div>
